/**
 * @description - Forbids everything outside of ASCII characters and '
 * @param {string} testValue - The string value to test
 * @returns {string} - Returns a string of forbidden characters that where found in the testValue
 */
const getForbiddenChars = (testValue: string): string => {
    const found = testValue.match(/([^\x20-\x7E]|')+/g);
    const foundArray = found?.flatMap((s: string) => s.split(''));
    return foundArray ? [...new Set(foundArray)].join('') : '';
};

export { getForbiddenChars };
